import '@/styles/theme/theme.css';
import { FCWC } from '@/types/utils';

export const ThemeProvider: FCWC = ({ children }) => <>{children}</>;
